import preview from './preview.vue';

export default {
    install(Vue) {
        const Constructor = Vue.extend(preview);
        const instance = new Constructor();
        instance.$mount(document.createElement('div'));
        document.body.appendChild(instance.$el);

        Vue.prototype.$preview = ({ current = '', urls = [] }) => {
            // init
            instance.show = false;
            instance.show2 = false;

            instance.movePercentage = 0;

            instance.show = true;
            setTimeout(() => {
                instance.show2 = true;
            }, 50);

            instance.current = current;
            instance.urls = urls;

            // console.log('instance', instance);
        };
    },
};
